// import { Container } from "../../base/layout"
import Blocks from "@/components/Blocks"
import Block from "@/components/wrappers/block"
import styles from "./content-with-form.module.css"

export default function ContentWithForm({ block }) {
  const { innerBlocks } = block

  if (innerBlocks.length === 0) {
    return null
  }

  return (
    <Block block={block} className={styles.wrapper}>
      <Blocks
        blocks={innerBlocks}
        settings={{
          "theme/gravity-form": {
            width: "bleed"
          }
        }}
      />
    </Block>
  )
}
